import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import CustomTabs, { tabsProps } from "../../../../../../components/Tabs";
import CustomSalary from "./CustomSalary";
import RangeBased from "./RangeBased";

const SalaryStructures = () => {
    const locations = useLocation();
    const navigateto = useNavigate();
    const [activeTab] = React.useState<string>(locations.pathname);

    const Tabs: tabsProps[] = [
        { key: 'range-based', label: 'Range Based', content: <RangeBased /> },
        { key: 'custom-salary', label: 'Custom Salary', content: <CustomSalary /> },
    ]

    useEffect(() => {
        navigateto(`${activeTab}/${Tabs[0].key}`, { replace: true });
    }, []);

    const onTabChange = (activeKey: string) => {
        console.log(activeKey);
    }

    return <CustomTabs tabs={Tabs} routes={true} onTabChange={onTabChange} />
}

export default SalaryStructures;